var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clips-container"},_vm._l((_vm.markers),function(marker){return _c('div',{key:marker.id,staticClass:"clips-marker",style:({
      '--color':    ("" + (marker.color)),
      top:          '32px',
      left:         marker.start + '%', 
      right:        (100 - marker.end) + '%',
      borderLeft:   '2px solid var(--color)',
      borderRight:  '2px solid var(--color)',
    }),on:{"mousedown":function($event){return _vm.onJumpToClip($event, marker);}}},[_c('div',{staticClass:"marker-background",style:({
        background: ("" + (marker.color))
      })}),_c('v-icon',{attrs:{"small":"","color":marker.color}},[_vm._v(" mdi-content-cut ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }